import { render } from "./TentangKami.vue?vue&type=template&id=7433babd"
import script from "./TentangKami.vue?vue&type=script&lang=js"
export * from "./TentangKami.vue?vue&type=script&lang=js"

import "./TentangKami.vue?vue&type=style&index=0&id=7433babd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__